import { SET_FIRE_ASSUMPTIONS, SET_FIRE_PROJECTION, FIRE_ASSUMPTIONS_INITIALIZED } from '../constants/actionTypes';
import { DEFAULT_ANNUAL_RETURN_RATE, DEFAULT_WITHDRAWAL_RATE } from '../constants/fireDefaults';

const initialState = {
  assumptions: {
    annualSpending: null,
    annualSavings: null,
    currentAge: null,
    annualReturnRate: DEFAULT_ANNUAL_RETURN_RATE,
    withdrawalRate: DEFAULT_WITHDRAWAL_RATE,
  },
  projection: {
    fireNumber: null,
    yearsToFire: null,
    retirementAge: null,
    progressPercent: null,
    yearlyData: [],
  },
  assumptionsLoaded: false,
};

const fireInfo = (state = initialState, action) => {
  switch (action.type) {
    case SET_FIRE_ASSUMPTIONS:
      return Object.assign({}, state, {
        assumptions: action.assumptions,
        assumptionsLoaded: true,
      });
    case FIRE_ASSUMPTIONS_INITIALIZED:
      return Object.assign({}, state, { assumptionsLoaded: true });
    case SET_FIRE_PROJECTION:
      return Object.assign({}, state, {
        projection: action.projection,
      });
    default:
      return state;
  }
};

export default fireInfo;
